export const emailReg = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
export const phoneReg = /^\d{3}\d{4}\d{4}$/;
export const strictPhoneReg = /^\d{3}-\d{4}-\d{4}$/;

// 아이디 유효성 검사
export const idReg = /^[a-zA-z0-9]{4,12}$/;

// 비밀번호 유효성 검사
export const pwReg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#$%^&*()+|=])[A-Za-z\d~!@#$%^&*()+|=]{8,15}$/;